function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { arrayOf, bool, elementType, exact, func, number, object, oneOf, oneOfType, shape, string } from 'prop-types';
import SovosToolbarToggles from '../../../sovos-toolbar-toggles';
import SovosToolbarToggle from '../../../sovos-toolbar-toggle';
import SovosToolbarGroup from '../../../sovos-toolbar-group';
import SovosToolbarDropdown from '../../../sovos-toolbar-dropdown';
import SovosMonthSelector from '../../../sovos-month-selector';
import SovosMonthRangePicker from '../../../sovos-month-range-picker';
import SovosToolbarDateSelector from '../../../sovos-toolbar-date-selector';
import { quickFilterTypes } from '../../../sovos-table-group/helpers/filterTypes';
const {
  toggle,
  dateSelector,
  dropdown,
  monthSelector,
  monthRangePicker
} = quickFilterTypes;
const components = {
  [dateSelector]: SovosToolbarDateSelector,
  [dropdown]: SovosToolbarDropdown,
  [monthSelector]: SovosMonthSelector,
  [monthRangePicker]: SovosMonthRangePicker
};
const QuickFilters = _ref => {
  let {
    disabled = false,
    onClearSelection,
    quickFilters
  } = _ref;
  const {
    items: unsortedItems,
    onApply,
    values
  } = quickFilters;
  const toggles = [];
  const nonToggles = [];
  unsortedItems.forEach(filter => {
    if (filter.type === toggle) {
      toggles.push(filter);
    } else {
      nonToggles.push(filter);
    }
  });
  const handleToggle = filter => {
    const newValue = values && values[filter] ? !values[filter] : true;
    const newValues = {
      ...values
    };
    newValues[filter] = newValue;
    onApply(newValues);
    onClearSelection();
  };
  const handleChange = (filter, filterOutput) => {
    const value = filterOutput.target ? filterOutput.target.value : filterOutput;
    const newValues = {
      ...values
    };
    newValues[filter] = value;
    onApply(newValues);
    onClearSelection();
  };
  const filterComponent = type => components[type] || type;
  const renderToggles = () => /*#__PURE__*/React.createElement(SovosToolbarToggles, null, toggles.map(filter => {
    const key = filter.dataKey || filter.label;
    return /*#__PURE__*/React.createElement(SovosToolbarToggle, {
      disabled: disabled,
      key: key,
      selected: values && values[key] === true,
      label: filter.label,
      onClick: () => handleToggle(key)
    });
  }));
  const renderNonToggles = () => nonToggles.map(filter => {
    const {
      type,
      label,
      dataKey,
      menuItems,
      ...otherProps
    } = filter;
    const Filter = filterComponent(type);
    const key = dataKey || label;
    return /*#__PURE__*/React.createElement(SovosToolbarGroup, {
      key: key
    }, /*#__PURE__*/React.createElement(Filter, _extends({
      disabled: disabled,
      onChange: filterOutput => handleChange(key, filterOutput),
      label: filter.label
    }, otherProps), type === dropdown && menuItems));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, !!nonToggles.length && renderNonToggles(), !!toggles.length && renderToggles());
};
export const quickFilterPropTypes = exact({
  items: arrayOf(shape({
    label: string,
    dataKey: oneOfType([string, number]),
    type: oneOfType([elementType, oneOf(Object.values(quickFilterTypes))]).isRequired
  })).isRequired,
  onApply: func.isRequired,
  values: object
});
QuickFilters.propTypes = {
  disabled: bool,
  onClearSelection: func.isRequired,
  quickFilters: quickFilterPropTypes.isRequired
};
export default QuickFilters;